import { FC } from 'react';

import { IWalletTag } from '@entities/wallet-tags';

import './WalletTagsCell.css';

interface IProps {
  /** Tags assigned to the wallet; may be undefined or empty. */
  tags?: IWalletTag[];
}

/**
 * Read-only display of a wallet's tags as colored chips, for the wallets table column.
 * Reuses the same color-mix tint as WalletTagsSelect so chips read consistently. All tags are
 * shown — the column is wide enough for the chips to wrap onto a few lines.
 */
export const WalletTagsCell: FC<IProps> = ({ tags }) => {
  if (!tags || tags.length === 0) {
    return <span className='wallet-tags-cell__empty'>—</span>;
  }

  return (
    <div className='wallet-tags-cell'>
      {tags.map(tag => (
        <span
          key={tag.id}
          className='wallet-tags-cell__chip'
          title={tag.name}
          style={
            tag.color
              ? { backgroundColor: `color-mix(in srgb, ${tag.color} 35%, var(--input-bg))` }
              : undefined
          }
        >
          {tag.name}
        </span>
      ))}
    </div>
  );
};
